import * as React from 'react';
import {connect} from 'react-redux';

import type {SalesDocumentType} from 'shells/lead-sidebar/sales-documents/types';

import type {NutshellState} from '../../../store';

import {openComposerWithId, promptOverrideMinimizedEmail} from '../../email/email-composer-actions';
import {getWasMinimizedForEntityId} from '../../email/email-composer-selectors';

function mapStateToProps(state: NutshellState): StateProps {
    return {
        minimizedForEntityId: getWasMinimizedForEntityId(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onSendEmailClicked: (
            entityId: string,
            originSalesDocumentType?: SalesDocumentType | null,
            seededWithEmailAddress?: string | null,
            seedWithAllPrimaryRelatedEmailAddresses?: boolean | null
        ) => {
            dispatch(
                openComposerWithId(
                    entityId,
                    false,
                    originSalesDocumentType,
                    seededWithEmailAddress,
                    seedWithAllPrimaryRelatedEmailAddresses
                )
            );
        },
        onPreventOpeningNewEmail: (entityId: string) => {
            dispatch(promptOverrideMinimizedEmail(entityId));
        },
    };
}

export type OwnProps = {
    entityId: string;
    postModalOpen: () => void;
    originSalesDocumentType?: SalesDocumentType | null | undefined;
    seededWithEmailAddress?: string | null | undefined;
    seedWithAllPrimaryRelatedEmailAddresses?: boolean | null | undefined;
};

type StateProps = {
    minimizedForEntityId: string | null | undefined;
};

type DispatchProps = {
    onSendEmailClicked: (
        entityId: string,
        originSalesDocumentType?: SalesDocumentType | null | undefined,
        seededWithEmailAddress?: string | null | undefined,
        seedWithAllPrimaryRelatedEmailAddresses?: boolean | null | undefined
    ) => void;
    onPreventOpeningNewEmail: (newEntityId: string) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

function TimelineCreatorEmailComponent(props: Props) {
    React.useEffect(() => {
        handleSendEmailButtonClicked();
        // This resets to the note tab after opening the send email modal
        setTimeout(() => {
            props.postModalOpen();
        }, 200);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSendEmailButtonClicked = () => {
        if (props.minimizedForEntityId && props.minimizedForEntityId !== props.entityId) {
            props.onPreventOpeningNewEmail(props.entityId);
        } else {
            props.onSendEmailClicked(
                props.entityId,
                props.originSalesDocumentType,
                props.seededWithEmailAddress,
                props.seedWithAllPrimaryRelatedEmailAddresses
            );
        }
    };

    return null;
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const TimelineCreatorEmail = connector(TimelineCreatorEmailComponent);
